import { environment } from '@environments/environment';

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { GoogleTagManagerService } from 'angular-google-tag-manager';

import {
    BaseAnalyticsEvent,
    AnalyticsBaseService,
    TagManagerBaseService,
    TagManagerService,
} from '@pnsk/ui-common/analytics';
import { FiAnalyticsTrackViewComponent } from '@pnsk/ui-common/analytics/track-view.component';

import { AnalyticsService } from './analytics.service';

const PROVIDERS = environment.production
    ? [
          {
              provide: 'googleTagManagerId',
              useValue: environment.externalConfig.ANALYTICS_KEY,
          },
          {
              provide: TagManagerBaseService,
              useClass: GoogleTagManagerService,
          },
      ]
    : [
          {
              provide: TagManagerBaseService,
              useClass: TagManagerService,
          },
      ];

@Component({
    selector: 'fi-track-view',
    template:
        '<fi-analytics-track-view [data]="data"></fi-analytics-track-view>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        ...PROVIDERS,
        {
            provide: AnalyticsBaseService,
            useClass: AnalyticsService,
        },
    ],
    standalone: true,
    imports: [FiAnalyticsTrackViewComponent],
})
export class TrackViewComponent {
    @Input() data: BaseAnalyticsEvent;
}
